import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import Delete from "../../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/delete.js";
import Check from "../../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/check.js";
function NumberKeypad({
  onInput,
  onClear,
  onSubmit,
  disabled = false,
  showSubmit = false,
  canSubmit = false
}) {
  const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
  return /* @__PURE__ */ jsx("div", { className: "fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg p-3 safe-area-inset-bottom", children: /* @__PURE__ */ jsx("div", { className: "max-w-lg mx-auto", children: /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-4 gap-2", children: [
    keys.slice(0, 3).map((key) => /* @__PURE__ */ jsx(NumberKey, { value: key, onClick: onInput, disabled }, key)),
    /* @__PURE__ */ jsx(
      "button",
      {
        onClick: onClear,
        disabled,
        className: cn(
          "h-14 rounded-xl flex items-center justify-center",
          "bg-gray-100 text-gray-600 font-semibold text-lg",
          "active:bg-gray-200 transition-colors",
          disabled && "opacity-50 cursor-not-allowed"
        ),
        children: /* @__PURE__ */ jsx(Delete, { className: "w-6 h-6" })
      }
    ),
    keys.slice(3, 6).map((key) => /* @__PURE__ */ jsx(NumberKey, { value: key, onClick: onInput, disabled }, key)),
    /* @__PURE__ */ jsx("div", {}),
    " ",
    keys.slice(6, 9).map((key) => /* @__PURE__ */ jsx(NumberKey, { value: key, onClick: onInput, disabled }, key)),
    showSubmit ? /* @__PURE__ */ jsx(
      "button",
      {
        onClick: onSubmit,
        disabled: disabled || !canSubmit,
        className: cn(
          "h-14 rounded-xl flex items-center justify-center",
          "font-semibold text-lg transition-all",
          canSubmit ? "bg-emerald-500 text-white active:bg-emerald-600" : "bg-gray-100 text-gray-400 cursor-not-allowed"
        ),
        children: /* @__PURE__ */ jsx(Check, { className: "w-6 h-6" })
      }
    ) : /* @__PURE__ */ jsx("div", {}),
    /* @__PURE__ */ jsx("div", {}),
    /* @__PURE__ */ jsx(NumberKey, { value: keys[9], onClick: onInput, disabled }),
    /* @__PURE__ */ jsx("div", {}),
    /* @__PURE__ */ jsx("div", {})
  ] }) }) });
}
function NumberKey({ value, onClick, disabled }) {
  return /* @__PURE__ */ jsx(
    "button",
    {
      onClick: () => onClick(value),
      disabled,
      className: cn(
        "h-14 rounded-xl flex items-center justify-center",
        "bg-white border border-gray-200 text-gray-800 font-semibold text-xl",
        "active:bg-gray-100 active:scale-95 transition-all",
        "hover:border-blue-300 hover:bg-blue-50",
        disabled && "opacity-50 cursor-not-allowed"
      ),
      children: value
    }
  );
}
export {
  NumberKeypad
};
//# sourceMappingURL=number-keypad.js.map
